import { ThemeProvider } from '@mui/material/styles'
import { FeatureFlagIdDarkMode } from 'c1gen/features'
import { C1Theme, C1DarkTheme } from 'c1ui'
import { useFeatureChecker } from 'components/no-ui/capability'
import { FC, ReactNode, useEffect, useState } from 'react'

interface C1ThemeProviderWithDarkModeProps {
    children: ReactNode
}

export const C1ThemeProviderWithDarkMode: FC<C1ThemeProviderWithDarkModeProps> = ({ children }) => {
    const hasDarkModeFeature = useFeatureChecker(FeatureFlagIdDarkMode)
    const [prefersDarkMode, setPrefersDarkMode] = useState(false)

    useEffect(() => {
        if (!hasDarkModeFeature) return

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        setPrefersDarkMode(mediaQuery.matches)

        const handleChange = (e: MediaQueryListEvent): void => setPrefersDarkMode(e.matches)

        mediaQuery.addEventListener('change', handleChange)

        return (): void => { mediaQuery.removeEventListener('change', handleChange) }
    }, [hasDarkModeFeature])

    // Use dark theme only if feature flag is enabled AND user prefers dark mode
    const shouldUseDarkTheme = hasDarkModeFeature && prefersDarkMode
    const theme = shouldUseDarkTheme ? C1DarkTheme : C1Theme

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
